import clsx from "clsx";
import { useTranslation } from "react-i18next";

import FileUploadStatusIcon from "@/components/shared/common/FileUploadStatusIcon";
import { Typography } from "@/components/ui/text/Typography/Typography";
import type { FileUploadState } from "@/data/media/useFileUpload";

interface IProps {
  file: File;
  status: FileUploadState;
}

const UploadsPageFileUploadRow = ({ file, status }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-row items-center justify-between border-elevation-outline-1 border-b px-3 py-2-5">
      <Typography size="body-3">{file.name}</Typography>
      <div className="flex flex-row items-center gap-2">
        <FileUploadStatusIcon status={status} />
        <Typography
          size="body-3"
          className={clsx(status === "error" && "text-info-error", status === "uploaded" && "text-info-success")}
        >
          {t(`uploads.files-upload-modal.upload-state-${status}`)}
        </Typography>
      </div>
    </div>
  );
};

export default UploadsPageFileUploadRow;
